import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-edit-text',
  templateUrl: './edit-text.component.html',
  styleUrls: ['./edit-text.component.scss'],
})
export class EditTextComponent implements OnInit {

  @Input() comment = "";
  @ViewChild('textarea') textarea:any;
  newComment="";

  constructor(private modalCtrl:ModalController) { }

  ngOnInit() {

    setTimeout(() => {
      this.textarea.setFocus();
    }, 1000);

  }

  close(data:any = null) {
    this.modalCtrl.dismiss(data);
  }

}
